import { Key } from 'react';
import { TableRowSelection } from 'antd/lib/table/interface';

interface Options {
    viewOnly?: boolean;
    selectedRowKeys?: Key[];
    onSelectedRowKeysChange?: (keys: Key[]) => void;
    preserveSelectedRowKeys?: boolean;
}

const getTableRowSelection = <T,>({
    viewOnly,
    selectedRowKeys,
    onSelectedRowKeysChange,
    preserveSelectedRowKeys,
}: Options): TableRowSelection<T> | undefined => {
    if (viewOnly) return undefined;

    return {
        selectedRowKeys,
        preserveSelectedRowKeys,
        onChange: (keys) => onSelectedRowKeysChange?.(keys),
        renderCell: (value, record, index: number, originNode: React.ReactNode) => {
            // Fixes navigating into the product if we click outside of the checkbox
            return {
                props: {
                    style: {},
                    onClick: (e: React.MouseEvent) => e.stopPropagation(),
                    onDoubleClick: (e: React.MouseEvent) => e.stopPropagation(),
                },
                children: (
                    <span onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
                        {originNode}
                    </span>
                ),
            };
        },
    };
};

export default getTableRowSelection;
